import {
  ApiServices,
  BetsService,
  UsersService,
  RoundsService,
  ApiServiceTypes,
  StatisticsService,
  environmentBuilder,
  TranslationService,
} from '@pascal/pascal-core';

import { gameName } from '../enums/gameConfigsAndUrls';

export const registerApis = () => {
  const { httpUrl: url, httpTranslationUrl } = environmentBuilder(gameName);

  ApiServices.register(ApiServiceTypes.BetsService, new BetsService({ url }));
  ApiServices.register(ApiServiceTypes.UsersService, new UsersService({ url }));
  ApiServices.register(ApiServiceTypes.RoundsService, new RoundsService({ url }));
  ApiServices.register(ApiServiceTypes.StatisticsService, new StatisticsService({ url }));
  ApiServices.register(
    ApiServiceTypes.TranslationService,
    new TranslationService({ url: httpTranslationUrl })
  );
};
